/**
 * Build a tree structure from a flat list of categories.
 * Each category has { slug, parentSlug, title, description, image, ... }
 * Returns an array of root nodes, each with a `children` array.
 */
export const buildCategoryTree = (flatCategories = []) => {
  const nodeMap = {};

  // Create nodes with children arrays
  flatCategories.forEach(cat => {
    nodeMap[cat.slug] = { ...cat, children: [] };
  });

  const roots = [];

  flatCategories.forEach(cat => {
    const node = nodeMap[cat.slug];
    if (cat.parentSlug && nodeMap[cat.parentSlug]) {
      nodeMap[cat.parentSlug].children.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
};

/**
 * Recursively find a node by slug in a tree.
 */
export const findNodeBySlug = (tree = [], slug) => {
  for (const node of tree) {
    if (node.slug === slug) return node;
    const found = findNodeBySlug(node.children, slug);
    if (found) return found;
  }
  return null;
};

/**
 * Collect the slug of a node plus all its descendants' slugs.
 */
export const getAllDescendantSlugs = (node) => {
  if (!node) return [];
  const slugs = [node.slug];
  (node.children || []).forEach(child => {
    slugs.push(...getAllDescendantSlugs(child));
  });
  return slugs;
};

/**
 * Return the breadcrumb path from root to the node with the given slug.
 * Uses the flat list to walk up parentSlug references.
 * Returns array of { slug, title } from root to target.
 */
export const getAncestorPath = (flatCategories = [], slug) => {
  const bySlug = {};
  flatCategories.forEach(cat => {
    bySlug[cat.slug] = cat;
  });

  const path = [];
  let current = bySlug[slug];
  while (current) {
    path.unshift({ slug: current.slug, title: current.title });
    current = current.parentSlug ? bySlug[current.parentSlug] : null;
  }
  return path;
};
